export default function SessionTracker({ completed = 0, total = 8, size = "sm" }) {
  const sz = size === "lg" ? "w-3.5 h-3.5" : "w-2.5 h-2.5";
  return (
    <div className="flex items-center gap-1.5" data-testid="session-tracker">
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={`${sz} rounded-full ${
            i < completed ? "bg-[hsl(var(--sage))]" : "bg-neutral-200"
          }`}
        />
      ))}
      <span className="ml-2 text-xs text-neutral-500 font-medium">
        {completed}/{total}
      </span>
    </div>
  );
}
